import script from "./ChainsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChainsComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChainsComponent.vue?vue&type=style&index=0&id=d41bb5ea&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d41bb5ea"]])

export default __exports__